import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import { couponLightboxStepStyles, couponLightboxStyles } from './css/new-styles';
import { Lightbox } from './lightbox';

import RecommendationIcon from '../media/RecommendationIcon.svg';
import ScheduledIcon from '../media/Coupon_step2_Scheduled_Illustration.svg';
import CouponIcon from '../media/CouponIcon.svg';

export const CouponLightboxStepNew = injectSheet(couponLightboxStepStyles)(({
  classes,
  description,
  stepNumber,
  i18n,
  icon,
}) => (
  <div className={classNames('coupon-step-block', classes.block)}>
    <img
      className={classNames('coupon-step-block-icon', classes.icon)}
      alt=""
      src={icon}
    />
    <span className="coupon-step-block-description">
      <span className={classNames('coupon-step-block-number', classes.titleStepNumber)}>
        {i18n.getString('Coupon_LightboxStepNumberNew', { stepNumber })}
      </span> {description}
    </span>
  </div>
));

CouponLightboxStepNew.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  icon: PropTypes.node.isRequired,
};

export const CouponLightboxNew = injectSheet(couponLightboxStyles)(({
  classes,
  coupon,
  i18n,
  isOpen,
  onCancel,
  onSubmit,
}) => {
  const steps = [
    {
      icon: RecommendationIcon,
      description: i18n.getString('Coupon_LightboxStep1Description', coupon),
    },
    {
      icon: ScheduledIcon,
      description: i18n.getString('Coupon_LightboxStep2Description'),
    },
    {
      icon: CouponIcon,
      description: i18n.getString(
        'Coupon_LightboxStep3Description',
        coupon
      ),
    },
  ];

  return (
    <Lightbox
      title={i18n.getString(
        'Coupon_LightboxTitleNew',
        coupon
      )}
      onCancel={_.debounce(onCancel, 1000, true)}
      onSubmit={_.debounce(onSubmit, 1000, true)}
      isOpen={isOpen}
      buttonOkText={i18n.getString('Coupon_GotIt')}
      showClose
      i18n={i18n}
    >
      <div className="coupon-lightbox">
        <div className={classNames('coupon-steps', classes.steps)}>
          {steps.map((step, idx) => (
            <CouponLightboxStepNew
              key={_.uniqueId('step-')}
              icon={step.icon}
              stepNumber={idx + 1}
              description={step.description}
              i18n={i18n}
            />
          ))}
        </div>
        <span className={classNames('coupon-terms', classes.terms)}>
          {i18n.getString('Coupon_Lightbox_LimitedTimeOffer_ActBy', coupon)}
        </span>
      </div>
    </Lightbox>
  );
});

CouponLightboxNew.propTypes = {
  coupon: PropTypes.shape({
    value: PropTypes.string.isRequired,
    expirationDate: PropTypes.string.isRequired,
    title: PropTypes.string,
    description: PropTypes.string.isRequired,
    descriptionShort: PropTypes.string.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  el: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

CouponLightboxNew.defaultProps = {
  isOpen: true,
};
